import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "push-debug-banner"
};
const _hoisted_2 = { class: "push-debug-banner-inner" };
const _hoisted_3 = { class: "mb-0" };
const _hoisted_4 = {
    key: 1,
    class: "push-debug-panel-wrap"
};
const _hoisted_5 = {
    key: 0,
    class: "badge-count"
};
const _hoisted_6 = {
    key: 1,
    class: "push-debug-panel card shadow"
};
const _hoisted_7 = { class: "card-header py-2 px-3 d-flex justify-content-between align-items-center" };
const _hoisted_8 = { class: "card-body py-2 px-3 small" };
const _hoisted_9 = { class: "mb-1" };
const _hoisted_10 = { class: "mb-1 text-break" };
const _hoisted_11 = { class: "text-muted" };
const _hoisted_12 = {
    key: 0,
    class: "mb-1 text-success"
};
const _hoisted_13 = {
    key: 1,
    class: "mb-2 text-danger text-break"
};
const _hoisted_14 = {
    key: 2,
    class: "text-success mb-2"
};
const _hoisted_15 = { class: "list-unstyled mb-0 push-debug-events" };
const _hoisted_16 = { class: "phase" };
const _hoisted_17 = { class: "time" };
const _hoisted_18 = { class: "summary" };
import { ref } from "vue";
import { usePushDebugStore } from "@/store/pushDebugStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PushDebugOverlay',
    setup(__props) {
        const store = usePushDebugStore();
        const copyHint = ref("");
        const formatTime = (iso) => {
            try {
                return new Date(iso).toLocaleTimeString("es-CL");
            }
            catch {
                return iso;
            }
        };
        const onCopy = async () => {
            const ok = await store.copyDiagnostics();
            copyHint.value = ok ? "Copiado" : "No se pudo copiar";
            window.setTimeout(() => {
                copyHint.value = "";
            }, 2500);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_unref(store).enabled && _unref(store).bannerVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(store).bannerTitle), 1),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(store).bannerBody), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn-close-banner",
                                "aria-label": "Cerrar aviso",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(store).bannerVisible = false))
                            }, " × ")
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(store).enabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (!_unref(store).panelExpanded)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "push-debug-pill",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(store).panelExpanded = true))
                            }, [
                                _cache[3] || (_cache[3] = _createTextVNode(" Push debug ")),
                                (_unref(store).events.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(store).events.length), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-semibold small" }, "Push debug (temporal)", -1)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm btn-link p-0",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_unref(store).panelExpanded = false))
                                    }, " Minimizar ")
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("p", _hoisted_9, [
                                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted" }, "Listeners:", -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(store).listenersReady ? "OK" : "pendiente"), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_10, [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(store).tokenLabel) + ":", 1),
                                        _createTextVNode(" " + _toDisplayString(_unref(store).fcmTokenPreview), 1)
                                    ]),
                                    (_unref(store).lastSubscribeOkAt)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Subscribe OK: " + _toDisplayString(formatTime(_unref(store).lastSubscribeOkAt)), 1))
                                        : _createCommentVNode("", true),
                                    (_unref(store).lastSubscribeError)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Subscribe error: " + _toDisplayString(_unref(store).lastSubscribeError), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", { class: "d-flex flex-wrap gap-1 mb-2" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-outline-primary btn-sm",
                                            onClick: onCopy
                                        }, " Copiar diagnóstico ")
                                    ]),
                                    (copyHint.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(copyHint.value), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("ul", _hoisted_15, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).events.slice(0, 8), (ev) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: ev.id,
                                                class: "push-debug-event"
                                            }, [
                                                _createElementVNode("span", _hoisted_16, _toDisplayString(ev.phase), 1),
                                                _createElementVNode("span", _hoisted_17, _toDisplayString(formatTime(ev.at)), 1),
                                                _createElementVNode("div", _hoisted_18, _toDisplayString(ev.summary), 1)
                                            ]));
                                        }), 128))
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("p", {
                                        class: "text-muted mb-0 mt-2",
                                        style: { "font-size": "0.65rem" }
                                    }, " Solo builds de desarrollo. En producción: localStorage PUSH_DEBUG_ENABLED=1 para forzar. ", -1))
                                ])
                            ]))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
